define("ProductViews.Price.View.Ext", [
  "ProductViews.Price.View",
  "Profile.Model",
  "Session",
  "SC.Configuration",

  "product_views_price.tpl",

  "Backbone",
  "underscore",
  "Utils",
], function (
  View,
  ProfileModel,
  Session,
  Configuration,

  product_views_price_tpl,

  Backbone,
  _,
  Utils
) {
  "use strict";

  _.extend(View.prototype, {
    getContext: _.wrap(View.prototype.getContext, function extendContext(fn) {
      var context = fn.apply(this, _.toArray(arguments).slice(1));
      var self = this;
      var profile = ProfileModel.getInstance();

      var multiplierMap = Configuration.get("speedmaster.MultiplerMap") || [];
      var isPDP =
        self.parentView &&
        self.parentView.attributes &&
        self.parentView.attributes["data-root-component-id"] ==
          "ProductDetails.Full.View";
      var priceDiff = context.comparePrice - context.price;
      var pricePercentage = context.comparePrice > 0
        ? Math.round(100 - (context.price / context.comparePrice) * 100)
        : 0;
      if (!isNaN(priceDiff)) {
        priceDiff = Utils.formatCurrency(
          priceDiff,
          SC.getSessionInfo("currency")
            ? SC.getSessionInfo("currency").symbol
            : "$"
        );
      }
      var item = context.model.get("item");
      var pointMultipler = "Single";
      var points = context.price;
      var bgcolor = "transparent";
      if (item) {
        pointMultipler = item.get("custitem_pointsmultiplier") || "Single";
        var objMultipler = _.find(multiplierMap, function (tisMultiplier) {
          return tisMultiplier.name == pointMultipler;
        });
        if (objMultipler && objMultipler.multiplier) {
          points = context.price * objMultipler.multiplier;
          bgcolor = objMultipler.bgcolor;
        }
      }

      var priceLevelMap = Configuration.get("speedmaster.PriceLevelMap") || [];
      var pricelevel = profile.get("priceLevel");
      var currentpricelevel = _.find(priceLevelMap, function (tisPriceLevel) {
        return tisPriceLevel.value == pricelevel;
      });
      // Fully authenticated — active server session, tier pricing applied.
      var is_loged_in =
        profile.get("isLoggedIn") === "T" && profile.get("isGuest") === "F";

      // Recognized — cookie persists, session expired. Items API returns
      // retail prices but we still know their tier. Template uses this
      // to show "Log in for Gold Pricing" instead of misleading label.
      var is_recognized =
        !is_loged_in && profile.get("isRecognized") === "T";

      return _.extend(context, {
        isPDP: isPDP,
        priceDiff: priceDiff,
        pricePercentage: pricePercentage,
        pointMultipler: pointMultipler,
        points: Math.round(points),
        bgcolor: bgcolor,
        isLoggedIn: is_loged_in,
        isRecognized: is_recognized,
        currentpricelevel: currentpricelevel,
      });
    }),
  });
});
